import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Smartphone, Bell, Lock, Wand2, GraduationCap, XCircle } from "lucide-react";

const items = [
  {
    icon: Smartphone,
    q: "Est-ce que mon enfant doit installer une application ?",
    a: "Non. Plan Étude est une application web : il l'ouvre dans le navigateur, sur téléphone ou ordinateur. Rien à installer. Les SMS restent limités au bilan d'étude et aux alertes importantes.",
  },
  {
    icon: Bell,
    q: "Et s'il ne répond pas à un rappel ?",
    a: "L'agent envoie une relance bienveillante. S'il n'y a toujours pas de réponse, l'événement est consigné dans le rapport parent — sans drame, sans surveillance pesante.",
  },
  {
    icon: Lock,
    q: "Est-ce sécuritaire ?",
    a: "Oui. Les conversations sont privées, les données sont chiffrées et nous ne partageons jamais les informations de votre enfant avec des tiers.",
  },
  {
    icon: Wand2,
    q: "Est-ce compliqué à utiliser ?",
    a: "Pas du tout. Vous créez le plan en 2 minutes, votre enfant l'accepte, et le reste est automatique.",
  },
  {
    icon: GraduationCap,
    q: "Est-ce que ça remplace l'école ?",
    a: "Non. Plan Étude ne remplace ni l'école ni le tutorat. C'est un coach d'engagement qui aide votre enfant à respecter le plan d'étude qu'il a accepté.",
  },
  {
    icon: XCircle,
    q: "Puis-je annuler quand je veux ?",
    a: "Oui, en un seul clic et sans frais. Aucun engagement, aucune carte requise pour l'essai gratuit de 30 jours.",
  },
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 sm:py-28"
      style={{ background: "var(--sp-bg-subtle)" }}
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase font-bold tracking-[0.2em] text-[#189346]">
            FAQ
          </div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#122118] leading-[1.1]">
            Questions fréquentes
          </h2>
          <p className="mt-4 text-lg text-[#4a5f53]">
            Des réponses simples aux questions que vous vous posez.
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {items.map((it, i) => (
            <div
              key={i}
              className="rounded-2xl bg-white border border-gray-100 overflow-hidden"
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center gap-4 p-5 sm:p-6 text-left hover:bg-gray-50/50 transition-colors"
                data-testid={`faq-toggle-${i}`}
                aria-expanded={open === i}
              >
                <span
                  className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0"
                  style={{ background: "#E9FBF0", color: "#189346" }}
                >
                  <it.icon className="w-5 h-5" />
                </span>
                <span className="flex-1 font-display font-semibold text-[#122118]">
                  {it.q}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${
                    open === i ? "rotate-180" : ""
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-6 pl-[4.25rem] text-[#4a5f53] leading-relaxed">
                      {it.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
